import { DateTimePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';

type ClearanceDateTimePickerProps = {
  label: string;
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  minDateTime?: Dayjs;
  maxDateTime?: Dayjs;
  ml?: string;
};

const ClearanceDateTimePicker = ({ label, value, onChange, minDateTime, maxDateTime, ml }: ClearanceDateTimePickerProps) => (
  <DateTimePicker
    label={label}
    value={value}
    minDateTime={minDateTime}
    maxDateTime={maxDateTime}
    onChange={onChange}
    slotProps={{
      textField: {
        slotProps: { inputLabel: { shrink: true } },
        size: 'small',
        sx: {
          ml,
          '& fieldset': { borderRadius: '10px' },
          '& .MuiPickersSectionList-root': { opacity: 1 }
        }
      },
      field: { clearable: true }
    }}
  />
);

export default ClearanceDateTimePicker;
